/*
(c) Copyright European Space Agency, 2023

Project name: THEMIS: Tracking the Health of the Environment and Missions in Space

Description:  General Inputs component for PMD Phase
Author: Deimos Space UK

Version: 1.0
*/

import React from 'react'
import { Row, Col, Form,  OverlayTrigger, Tooltip, } from 'react-bootstrap';
import style from '../PMDPhase.module.css'
function GeneralInputs(props) {
    const transformDate = (date) => {
        const newDate = new Date(date);
        const year = newDate.getFullYear();
        let month = newDate.getMonth() + 1;
        let day = newDate.getDate();
        if (month < 10) {
            month = "0" + month;
        }
        if(day < 10){
            day = "0" + day;
        }
        const formattedDate = year + "-" + month + "-" + day;
        return formattedDate;
      }
      
    return (
        <div>
            <Row>
                <Col xs={6} md={4} >
                    <Form.Group className={style.manualInput} controlId="startDate">
                        <Form.Label  style={{ color: '#003247' }}>Start epoch</Form.Label>
                        <Form.Control 
                        isInvalid={props?.step4?.startEpoch > props?.step4?.endEpoch && props?.step4?.endEpoch !== ''}
                        disabled={props.disabled} 
                        value={(props?.step4?.startEpoch)} 
                        onChange={e => {
                            props.changeStarEpoch(e.target.value, props?.orbit)
                        }} 
                        type="date" />
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col xs={6} md={4} >

                    <Form.Group className={style.manualInput} controlId="endDate">
                        <Form.Label  style={{ color: '#003247' }}>Cross section [m <sup>2</sup>]</Form.Label>
                        <Form.Control 
                        isInvalid={(isNaN(props?.step4?.crossSection) && props?.step4?.crossSection !== '') || props?.step4?.crossSection < 0}
                        disabled={props.disabled}  
                        value={props?.step4?.crossSection} 
                        onChange={e => props.changeCrossSection(e.target.value,props?.orbit)} 
                        type="string" />
                    </Form.Group>
                </Col >
                <Col xs={6} md={4} >
                    <Form.Group className={style.manualInput} controlId="eccentricity">
                        <Form.Label  style={{ color: '#003247' }}>Drag coefficient</Form.Label>
                        <Form.Control 
                        isInvalid={(isNaN(props?.step4?.dragCoefficient) && props?.step4?.dragCoefficient !== '') || props?.step4?.dragCoefficient < 0}
                        disabled={props.disabled}  
                        value={props?.step4?.dragCoefficient} 
                        onChange={e => props.changeDragCoefficient(e.target.value, props?.orbit)} />
                    </Form.Group>
                </Col>
                <Col xs={6} md={4} >
                    <Form.Group className={style.manualInput} controlId="semiMajorAxis">
                    <OverlayTrigger
                          key={'right'}
                          placement={'left'}
                          overlay={
                            <Tooltip id={`tooltip-right`}>
                              Reflectivity coefficient should be between 0 and 2
                          </Tooltip>
                          }>
                        <Form.Label  style={{ color: '#003247' }}> Reflectivity coefficient</Form.Label>
                        </OverlayTrigger>
                        <Form.Control 
                        isInvalid={(isNaN(props?.step4?.reflectivityCoefficient) && props?.step4?.reflectivityCoefficient !== '') || props?.step4?.reflectivityCoefficient < 0}
                        disabled={props.disabled}  
                        value={props?.step4?.reflectivityCoefficient} 
                        onChange={e => props.changeReflectivityCoefficient(e.target.value, props?.orbit)} />
                    </Form.Group>
                </Col>
               

            </Row>

        </div>
    )
}

export default GeneralInputs